export default function RestInfo({restData}){
    return(
        <>
        <div className="flex w-full justify-between mb-2 pb-2">
            <div className="w-[70%]">
                <p className="text-2xl text-gray-700 fond-semibold mb-1">{restData?.name}</p>
                <p  className="text-xl">{"₹"+restData?.defaultPrice/100}</p>
                <span  className="text-green-700">{restData?.ratings?.aggregatedRating?.rating}</span>
                 <span>{"("+restData?.ratings?.aggregatedRating?.ratingCountV2+")"}</span>
                 <p>{restData?.description}</p>
            </div>
            <div className="w-[20%] relative h-42">
                <img className="w-60 h-36 object-cover rounded-3xl" src={"https://media-assets.swiggy.com/swiggy/image/upload/"+restData.imageId}></img>
                <button className="absolute bottom-1 left-20 rounded-xl text-green-600 px-6 py-2 bg-white shadow-md border">ADD</button>
            </div>
        </div>
        <hr className="mb-6 mt-2"></hr>
        </>
    )
}